import App from '@/components/app.vue';

export const routes = [
    {
        path: '/login',
        name: '$login',
        meta: { privilege: 'PUBLIC' },
        component: () => import('@/module/public/login.vue'),
    },
    {
        path: '/logout',
        name: '$logout',
        meta: { privilege: 'SES_EXEC_SESSION' },
        component: () => import('@/module/public/logout.vue'),
    },
    {
        path: '/',
        redirect: '/profile',
        component: App,
        children: [
            {
                path: '/profile',
                name: '$menu.user.PROFILE',
                meta: { privilege: 'SES_VIEW_PROFILE' },
                component: () => import('@/module/user/profile.vue'),
            },
            /*
            {
                path: '/admin',
                name: 'Administration',
                meta: { privilege: 'SES_VIEW_MANAGER' },
                component: () => import('@/module/admin/list.vue')
            },
             */
            {
                path: '/registry',
                name: '$menu.registry.DEVICE_LIST',
                meta: { privilege: 'REG_VIEW_DEVICELIST' },
                component: () => import('@/module/registry/form.vue'),
            },
        ],
    },
    { path: '*', redirect: 'profile' },
];
